module.exports = __webpack_public_path__ + "static/media/brooke.ace3afc4.png";